import type { DocumentError } from 'apiConnector/document/document';
import classnames from 'classnames';
import { ErrorIcon } from 'components/shared/Document/ErrorIcon';
import type { ErrorDisplayContext } from 'components/shared/Document/MultiLanguageDocumentItem';
import { DocumentType } from 'models/documents/DocumentType';
import { FC } from 'react';

export interface BlotterPanelDocumentDownloadButtonProps {
  className?: string;
  e2e: string;
  error?: DocumentError;
  onClicked: () => void;

  documentType: DocumentType;
}

export const BlotterPanelDocumentDownloadButton: FC<BlotterPanelDocumentDownloadButtonProps> = ({
  className,
  e2e,
  error,
  documentType,
  onClicked,
}) => {
  const errorContext: ErrorDisplayContext = {
    shouldDisplayErrorDetails: true,
    shouldDisplayStandardErrorMessage: false,
    shouldUseRejectionCode: false,
  };
  return (
    <>
      <button
        data-e2e={e2e}
        type="button"
        className={classnames(
          'btn btn-sm btn-flat-secondary d-flex flex-row align-items-center justify-content-center',
          className,
        )}
        onClick={onClicked}
      >
        <i className="icon icon-sm">save_alt</i>
      </button>
      {error && (
        <ErrorIcon
          e2e={e2e}
          error={error}
          documentType={documentType}
          errorContext={errorContext}
          isInitiallyOpened={true}
        />
      )}
    </>
  );
};

BlotterPanelDocumentDownloadButton.displayName = 'BlotterPanelDocumentDownloadButton';
